import { c as _c } from "react/compiler-runtime";
import { ArrowTopRightIcon } from '@radix-ui/react-icons';
import { Button } from './primitives/button';
import React, { PropsWithChildren, useCallback } from 'react';
import { cn } from '@/utils/shad';
import { WithClassName, WithDisabled, WithOnClick } from '@/types/component';
import { ReasonDialogContent } from '@/domains/live-activity/interactions/components/ReasonDialog';
import { useDialogs } from '@/contexts/dialogs/hooks';
import { IconType } from '@/constants/icons';
type BaseProps = PropsWithChildren<WithClassName & WithOnClick & WithDisabled> & {
  appendIcon?: IconType | null;
};
type ReasonDialogVariantProps = {
  // permissions to have to enable the button
  onReasonSubmitted?: (reason: string) => void;
  reasonValue: string;
};
type Props = BaseProps & (({
  enableReasonDialogMode?: true;
} & ReasonDialogVariantProps) | {
  enableReasonDialogMode?: false;
});
export function ViewDetailsButton(t0) {
  const $ = _c(20);
  let children;
  let className;
  let disabled;
  let onClick;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      onClick,
      disabled,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = disabled;
    $[4] = onClick;
    $[5] = rest;
  } else {
    children = $[1];
    className = $[2];
    disabled = $[3];
    onClick = $[4];
    rest = $[5];
  }
  if (rest.enableReasonDialogMode) {
    let t1;
    if ($[6] !== children || $[7] !== className || $[8] !== disabled || $[9] !== onClick || $[10] !== rest.appendIcon || $[11] !== rest.onReasonSubmitted || $[12] !== rest.reasonValue) {
      t1 = <ViewDetailsButtonWithReasonDialog className={className} disabled={disabled} onReasonSubmitted={rest.onReasonSubmitted} reasonValue={rest.reasonValue} onClick={onClick} appendIcon={rest.appendIcon}>{children}</ViewDetailsButtonWithReasonDialog>;
      $[6] = children;
      $[7] = className;
      $[8] = disabled;
      $[9] = onClick;
      $[10] = rest.appendIcon;
      $[11] = rest.onReasonSubmitted;
      $[12] = rest.reasonValue;
      $[13] = t1;
    } else {
      t1 = $[13];
    }
    return t1;
  }
  let t1;
  if ($[14] !== children || $[15] !== className || $[16] !== disabled || $[17] !== onClick || $[18] !== rest.appendIcon) {
    t1 = <ViewDetailsButtonBase className={className} onClick={onClick} disabled={disabled} appendIcon={rest.appendIcon}>{children}</ViewDetailsButtonBase>;
    $[14] = children;
    $[15] = className;
    $[16] = disabled;
    $[17] = onClick;
    $[18] = rest.appendIcon;
    $[19] = t1;
  } else {
    t1 = $[19];
  }
  return t1;
}
type ViewDetailsButtonWithReasonDialogProps = BaseProps & ReasonDialogVariantProps;

/**
 * the onClick is executed only if the user provides a reason
 *
 * @param onClick
 * @param className
 * @param children
 * @param disabled
 * @param onReasonSubmitted
 * @constructor
 */
function ViewDetailsButtonWithReasonDialog(t0) {
  const $ = _c(14);
  const {
    className,
    children,
    disabled,
    onReasonSubmitted,
    reasonValue,
    onClick,
    appendIcon
  } = t0;
  const dialogs = useDialogs();
  let t1;
  if ($[0] !== onReasonSubmitted) {
    t1 = newReason => {
      onReasonSubmitted?.(newReason);
    };
    $[0] = onReasonSubmitted;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSubmitReason = t1;
  let t2;
  if ($[2] !== dialogs || $[3] !== disabled || $[4] !== handleSubmitReason || $[5] !== onClick || $[6] !== reasonValue) {
    t2 = ev => {
      if (disabled) {
        return;
      }
      if (reasonValue) {
        onClick?.(ev);
        return;
      }
      dialogs.push({
        content: <ReasonDialogContent reason={reasonValue ?? ""} onSubmit={handleSubmitReason} />
      });
    };
    $[2] = dialogs;
    $[3] = disabled;
    $[4] = handleSubmitReason;
    $[5] = onClick;
    $[6] = reasonValue;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleClick = t2;
  let t3;
  if ($[8] !== appendIcon || $[9] !== children || $[10] !== className || $[11] !== disabled || $[12] !== handleClick) {
    t3 = <ViewDetailsButtonBase appendIcon={appendIcon} className={className} onClick={handleClick} disabled={disabled}>{children}</ViewDetailsButtonBase>;
    $[8] = appendIcon;
    $[9] = children;
    $[10] = className;
    $[11] = disabled;
    $[12] = handleClick;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}
function ViewDetailsButtonBase(t0) {
  const $ = _c(8);
  const {
    onClick,
    className,
    children,
    disabled,
    appendIcon
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("gap-1 text-[12px] font-normal text-muted-foreground hover:text-white", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = appendIcon === null ? undefined : appendIcon ?? ArrowTopRightIcon;
  const t3 = children || "View details";
  let t4;
  if ($[2] !== disabled || $[3] !== onClick || $[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <Button variant="link" className={t1} onClick={onClick} AppendIcon={t2} disabled={disabled}>{t3}</Button>;
    $[2] = disabled;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}